import { Box, Group, Stack, Text, Title } from "@mantine/core";
import { ButtonCheckboxV2 } from "./ButtonCheckboxV2";
import type { ButtonsSelectProps, DataItem } from "./ButtonSelect";
import {
  getNextValue,
  handleGroupBlur,
  isDataGroupItemGroup,
} from "./ButtonSelect.utils";

const ButtonGroup = ({
  data,
  value,
  onChange,
  error,
  allowDeselect,
}: Pick<
  ButtonsSelectProps,
  "value" | "onChange" | "error" | "allowDeselect"
> & {
  data?: string[] | DataItem[];
}) => {
  return (
    <Group gap="s2">
      {data?.map(item => {
        const itemValue = typeof item === "string" ? item : item.value;
        const itemLabel = typeof item === "string" ? item : item.label;
        const itemDescription =
          typeof item === "string" ? undefined : item.description;

        return (
          <ButtonCheckboxV2
            id={itemValue}
            key={itemValue}
            description={itemDescription}
            onClick={() =>
              onChange(getNextValue(itemValue, { value, allowDeselect }))
            }
            isActive={itemValue === value}
            error={error}
          >
            {itemLabel}
          </ButtonCheckboxV2>
        );
      })}
    </Group>
  );
};

export const ButtonSelectV2 = ({
  data,
  value,
  onChange,
  error,
  label,
  allowDeselect,
  onBlur,
}: ButtonsSelectProps) => {
  return (
    <Stack gap="xs" onBlur={handleGroupBlur(onBlur)}>
      {label && (
        <Text size="sm" variant="strong">
          {label}
        </Text>
      )}
      {isDataGroupItemGroup(data) ? (
        <Box style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
          {data.map((groupData, groupIndex) => (
            <Box key={groupIndex}>
              {groupData.group && (
                <Title
                  order={6}
                  style={{ marginBottom: "10px", fontWeight: 600 }}
                >
                  {groupData.group}
                </Title>
              )}
              <Group>
                <ButtonGroup
                  data={groupData.items}
                  value={value}
                  onChange={onChange}
                  error={error}
                  allowDeselect={allowDeselect}
                />
              </Group>
            </Box>
          ))}
        </Box>
      ) : (
        <ButtonGroup
          data={data}
          value={value}
          onChange={onChange}
          error={error}
          allowDeselect={allowDeselect}
        />
      )}
      {error && (
        <Text size="sm" c="error">
          {error}
        </Text>
      )}
    </Stack>
  );
};
